import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../../../config/url.config";
import { navigateToSessionExpired } from "../../../utils/sessionExpired";
import { checkDocumentIsUpdatedByUser, documentsWasUpdatedByUser } from "../../../utils/updatedByUser";
import { getAuthHeader } from "../../../utils/superFetch";

export const handleListTaxiCompanies = async (setListTaxiCompanies) => {
    const config = {
        headers: {
          "content-type": "application/json",
          ...getAuthHeader(),
        },
    };

    try {
        const res = await axios.get(
          `${ONBOARDING_API_ENDPOINT}/api/onboarding/getTaxiCompanies`,
          config
        );

        let taxiCompanies = res.data.result.map((t) => {
            return t.name })
            setListTaxiCompanies(taxiCompanies)
    } catch (err) {
        console.log("taxi company" , err)
    }
}

export const handleLoadUserSelectedtaxiCompany = (itemIndex, requirementDocuments, setSelectedTaxiCompany) => {
    for (let requiredItems of requirementDocuments[itemIndex].requiredItems) {
        if ( requiredItems.value !== "" && requiredItems.itemName === "taxiCompany") {
            setSelectedTaxiCompany(requiredItems.value);
        } 
      }
}

// export const handleUserSelectedCompany = () => 
export const updateMemberRequirement = (memberRequirement,setMemberRequirement, itemIndex, itemName, updatedValue, updatedUrl) => {
    let tmpData = {...memberRequirement}
    for (let i = 0 ; i< tmpData.requiredDocuments[itemIndex].requiredItems.length ;i++) {
      if (
        itemName === tmpData.requiredDocuments[itemIndex].requiredItems[i].itemName
      ) {
        if(tmpData.requiredDocuments[itemIndex].requiredItems[i].status === 2 || 
          tmpData.requiredDocuments[itemIndex].requiredItems[i].value !== '') {
          documentsWasUpdatedByUser(`${tmpData.requiredDocuments[itemIndex].item}`)
        }
        tmpData.requiredDocuments[itemIndex].requiredItems[i].value = updatedValue
        tmpData.requiredDocuments[itemIndex].requiredItems[i].url = updatedUrl
        break
      }
    }
    setMemberRequirement(tmpData)
    return
  }

export const handleUserSelectedCompany = async (companyName, profileId, memberRequirement,setMemberRequirement, itemIndex, navigate,
  setVisible, setShowTaxiCompany, setShowSaveButton) => {
    let body = {
      item: "taxiCompany",
      requiredItems: [
        {
          itemName: "taxiCompany",
          value:companyName,
        },
      ],
    };
    const config = {
      headers: {
        "content-type": "application/json",
        "upload-document": false,
        ...getAuthHeader(),
      },
    };
    try {
      const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileId}`;
      const res = await axios.post(endpoint, body, config);
      if (res.status) {
        let tmpMemberData = { ...memberRequirement };
        checkIfAllDocumentsAreUploaded(tmpMemberData, setShowSaveButton)
        for (
          let i = 0;
          i <
          tmpMemberData.requiredDocuments[itemIndex].requiredItems.length;
          i++
        ) {
          if (
            tmpMemberData.requiredDocuments[itemIndex].requiredItems[i]
              .itemName === "taxiCompany"
          ) {
            updateMemberRequirement(
              memberRequirement,
              setMemberRequirement,
              itemIndex,
              tmpMemberData.requiredDocuments[itemIndex].requiredItems[i]
                .itemName,companyName
              
            );
          }


        }


      }
      setVisible(false)
      setShowTaxiCompany(false)
    } catch (error) {
      navigateToSessionExpired(navigate, {
        reason: "taxi_company_submit_failed",
        source: "handleUserSelectedCompany",
        component: "TaxiCompany",
        status: error?.response?.status,
        message: error?.message,
      });
    }
  }

  export const checkIfAllDocumentsAreUploaded = (memberRequirement, setShowSaveButton) => {
    for(let doc of memberRequirement.requiredDocuments) {
      for (let item of doc.requiredItems) {
        if (item.value === '' && doc.item !== "emergencyContact" && item.itemName !== "letterOfEmployment" && item.itemName !== "taxiCompany" ) {
          setShowSaveButton(() => false)
          return
        } else if (item.status === 2 && !checkDocumentIsUpdatedByUser(doc.item)) {
          setShowSaveButton(() => false)
          return
        } else {
          continue
        }
      }
    }
    setShowSaveButton(() => true)
    return
  }